/* eslint-disable jsx-a11y/anchor-is-valid */
import { getClientNames } from '@buyerflo/core/schemas/purchaser'
import { StatusBadge } from '@buyerflo/ui/components/StatusBadge'
import { getPurchaserBudget } from '@buyerflo/ui/utils/purchaser'
import { usePurchaserConfigApi, usePurchasersApi, useUserName } from 'apiProviders'
import { useNavigate } from 'react-router'
import { Virtuoso } from 'react-virtuoso'
import { Text, View, XStack, YStack } from 'tamagui'
import { useOptionalOnboarding } from '../../onboarding/OnboardingContext'

export default ({ purchasersApi }: { purchasersApi: ReturnType<typeof usePurchasersApi> }) => {
    const navigate = useNavigate()
    const userName = useUserName()
    const purchaserConfigApi = usePurchaserConfigApi()
    const onboarding = useOptionalOnboarding()
    const firstPurchaserId = onboarding?.testPurchaserId ?? onboarding?.progress?.firstPurchaserId

    return (
        <View
            display="flex"
            $sm={{ display: 'none' }}
            height="100%"
        >
            <Virtuoso
                style={{ height: '100%', width: '100%' }}
                data={purchasersApi.data ?? []}
                computeItemKey={(index, purchaser) => purchaser.purchaserId}
                endReached={() => {
                    console.log('end reached')
                }}
                itemContent={(index, purchaser) => (
                    <View
                        width="100%"
                        paddingBottom="$2"
                    >
                        <XStack
                            cursor="pointer"
                            justifyContent="space-between"
                            alignItems="flex-start"
                            paddingHorizontal="$3"
                            paddingVertical="$3"
                            hoverStyle={{
                                backgroundColor: '$backgroundHover',
                            }}
                            borderRadius="$4"
                            borderWidth={1}
                            borderColor="$borderColor"
                            backgroundColor="$backgroundStrong"
                            onPress={() => navigate(purchaser.purchaserId)}
                            {...(purchaser.purchaserId === firstPurchaserId ? { 'data-tour': 'first-purchaser-row' } : {})}
                        >
                            <XStack
                                gap="$4"
                                justifyContent="space-between"
                                flex={1}
                            >
                                <View gap="$1" flex={1} minWidth={0}>
                                    <Text fontWeight="600" fontSize="$4">{getClientNames(purchaser.buyers)}</Text>
                                    <Text fontSize="$2" color="$colorMuted">
                                        {purchaser.agents.map(({ userId }) => userName(userId)).join(', ')}
                                    </Text>
                                    {getPurchaserBudget(purchaser) ? (
                                        <Text fontSize="$2" color="$colorSoft" fontFamily="$mono">
                                            {getPurchaserBudget(purchaser)}
                                        </Text>
                                    ) : null}
                                </View>
                                <YStack
                                    alignItems="flex-end"
                                    justifyContent="space-between"
                                    gap="$2"
                                >
                                    <StatusBadge status={purchaser.purchaserStatus} />
                                    <View>
                                        {purchaserConfigApi.data ? (
                                            <XStack gap="$1.5">
                                                {purchaserConfigApi.data.map(config => {
                                                    const value = purchaser.additionalDetails
                                                        ? (config.configValues.find(
                                                              v =>
                                                                  v.value ===
                                                                  purchaser.additionalDetails[config.id],
                                                          ) ?? config.configValues[0])
                                                        : config.configValues[0]

                                                    return (
                                                        <View
                                                            key={config.id}
                                                            width={12}
                                                            height={12}
                                                            borderRadius={6}
                                                            backgroundColor={`$${value.color}7`}
                                                        />
                                                    )
                                                })}
                                            </XStack>
                                        ) : (
                                            <Text fontSize="$2" color="$gray9">...</Text>
                                        )}
                                    </View>
                                </YStack>
                            </XStack>
                        </XStack>
                    </View>
                )}
            />
        </View>
    )
}
